import assetRegistry from '@dialogexe/cw-asset-provider/core/AssetRegistry';

assetRegistry.register('arrow-left-white', require('./img/arrow-left-white.svg'));
assetRegistry.register('arrow-right-white', require('./img/arrow-right-white.svg'));
assetRegistry.register('arrowhead-down', require('./img/arrowhead-down.svg'));
assetRegistry.register('arrowhead-down-white', require('./img/arrowhead-down-white.svg'));
assetRegistry.register('arrowhead-right', require('./img/arrowhead-right.svg'));
assetRegistry.register('arrow-left', require('./img/arrow-left.svg'));
assetRegistry.register('arrow-left-inactive', require('./img/arrow-left-inactive.svg'));
assetRegistry.register('arrow-right', require('./img/arrow-right.svg'));
assetRegistry.register('arrow-right-inactive', require('./img/arrow-right-inactive.svg'));
assetRegistry.register('play', require('./img/play.svg'));
assetRegistry.register('star-yellow', require('./img/star-yellow.svg'));
assetRegistry.register('star-empty', require('./img/star-empty.svg'));
assetRegistry.register('search-big', require('./img/search-big.svg'));
assetRegistry.register('search', require('./img/search.svg'));
assetRegistry.register('hamburger', require('./img/hamburger.svg'));
assetRegistry.register('close', require('./img/close.svg'));
assetRegistry.register('close-white', require('./img/close-white.svg'));
assetRegistry.register('close-white-small', require('./img/close-white-small.svg'));
assetRegistry.register('kinoklubb-black', require('./img/kinoklubb-black.png'));
assetRegistry.register('exclamation', require('./img/exclamation.svg'));
assetRegistry.register('profile', require('./img/profile.svg'));
assetRegistry.register('e-remove', require('./img/e-remove.svg'));
assetRegistry.register('frame-c-arrow-right', require('./img/frame-c-arrow-right.svg'));
assetRegistry.register('event-ticket', require('./img/event-ticket.svg'));
